import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import $ from "jquery";
import { confirmAlert } from "react-confirm-alert";
import { useNavigate, useParams, Link } from "react-router-dom";
import { transformBlankToNull } from "../../../services/Util";
import { ActiveMultiAssigneeIcon,ActiveAssigneeManIcon,DownArrowIconWorkflow } from "../../../AppIcons";
import Constants from "../../../Constants";
import { RotatingLines } from "react-loader-spinner";
import {
  getAxiosResponse,
  putAxiosResponse,
  deleteAxiosResponse,
} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
export default function LanguageReviewWorkflow() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const backRef = useRef();
  const errorRef = useRef(null);
  const removeRef = useRef(null);
  const assigneeRef = useRef(null)
  const param = useParams();
  const navigate = useNavigate();
  const translate = t;
  const [showEditAssignee, setShowEditAssignee] = useState("");
  const [langauageReviewers, setLangauageReviewers] = useState([]);
  const [langauageFinalReviewers, setFinalLangauageReviewers] = useState([]);
  const [otherUsers, setOtherUsers] = useState([]);
  const [otherFinalUsers, setFinalOtherUsers] = useState([]);
  const [finalTranslators, setInternaltTranslators] = useState([]);
  const [translators, setTranslators] = useState([]);
  const [selectedLanguages, setLanguageSelect] = useState([]);
  const [reviewIndexForLanguage, setReviewIndex] = useState("");
  const [workAssigneeList, setWorkAssigneeList] = useState([]);
  const [workFinalAssigneeList, setWorkFinalAssigneeList] = useState([]);
  const [validationErrors, setValidationErrors] = useState("");
  const [showHideModel, setShowHideModel] = useState(false);
  const [workflow, setWorkflow] = useState([]);
  const [steps, setSteps] = useState([]);
  const [targetLanguages, setTargetLanguages] = useState([]);
  const [toggleexpanded, setToggleexpanded] = useState(false);
  const [loader, setLoader] = useState(true);
  const [selectedUser,setSelectedUser] = useState([])
  const [stepDetail,setStepDetail] = useState({})
  const [validationErrorForAssignee, setValidationErrorForAssignee] = useState(
    []
  );
  const [defaultSelectedLangs, setDefaultSelectedLangs] = useState([]);
  const [filteredLanguagesForSchedule, setFilteredLanguagesForSchedule] =
    useState([]);
  const [languageReviewerTemplate, setLanguageReviewerTemplate] = useState([]);
  const [languageUpdateSucess, setSucessMessageStatus] = useState(false);
  const toggleAssignee = (reviewIndex, stepIndex, phaseIndex,e) => {
        if(e.type === 'click' || e.code === 'Enter'){
          `review${reviewIndex}step${stepIndex}phase${phaseIndex}` === showEditAssignee
            ? setShowEditAssignee("")
            : setShowEditAssignee(
                `review${reviewIndex}step${stepIndex}phase${phaseIndex}`
              );
        }   
  };
  const handleClickOutside = (event) => {
    const list = event.target.classList.contains("workflow-wrap");
    const list1 = event.target.classList.contains("setting-review-flow");
    const list2 = event.target.classList.contains("flex-align-center");
    const box = event.target.classList.contains("step-box-list");
    const button = event.target.classList.contains("workflow-step-content");
    const paperroot = event.target.classList.contains("popup-padding");
    const create_workflow = event.target.classList.contains(
      "create-new-review-workflow"
    );
    // const svgItem = event.target.closest('.MuiSvgIcon-root');
    const dashboard = event.target.classList.contains("flex");
    if (
      list ||
      list1 ||
      list2 ||
      box ||
      dashboard ||
      button ||
      paperroot ||
      create_workflow
    ) {
      setShowEditAssignee("");
    }
  };
  document.addEventListener("click", handleClickOutside, true);
  const getPhaseName = (phase, step, phaseIndex, stepIndex) => {
    if (phase.name !== "") {
      return <span>{phase.name}</span>;
    } else if (
      phase.phaseType.originalEnum === "WORK" &&
      step.stepNumber === 1 &&
      phase.phaseNumber === 1
    ) {
      return <strong>Translation Due</strong>;
    } else if (
      phase.phaseType.originalEnum === "REVIEW" &&
      steps.length - 1 === stepIndex &&
      steps[stepIndex].phases.length - 1 === phaseIndex
    ) {
      return <strong>Final Review</strong>;
    } else {
      return <strong>{phase.phaseType.display} due</strong>;
    }
  };

  const toggleStepExpansion = (e) => {
    toggleexpanded ? setToggleexpanded(false) : setToggleexpanded(true);
     var step = e.target.closest(".workflow-step-list");
    if(step.classList.contains('open-step')) {
        step.classList.remove('open-step')
    } else {
        step.classList.add('open-step')
    }
    e.stopPropagation();
}
  
  const EditAssigneeComponent = (prop) => {
    return (
      <div className="popover-body show">
        <div className="inner-popover maxHeight260">
          {langauageFinalReviewers.length > 0 ? (
            <div className="group-radio-list">
              <div
                style={{
                  padding: "0 0 10px",
                  fontWeight: "600",
                }}
              ><span tabIndex={-1}>Language Reviewers</span></div>
              {langauageFinalReviewers.map((user, index) => {
                return (
                  <div className="radio-form-check" key={`rev-${index}`}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      value={user.userId}
                      checked={
                        prop.defaultSelectedUsers.length > 0 ?
                        prop.multiAssignee ?
                        prop.defaultSelectedUsers.some(element => {
                          if (element.userId === user.userId) {
                            return true;
                          }
                          return false;
                        }) : 
                        prop.defaultSelectedUsers[0]?.userId === user.userId:
                        false
                      }
                      name={'radio'+index}
                      id={prop.reviewIndex + "-" + user.userId}
                      onKeyDown={(e) => {selectAssignee(
                        e,
                        prop.phaseIndex,
                        prop.stepIndex,
                        prop.reviewIndex,
                        user,
                        index,
                        prop.multiAssignee
                      )}}
                      onChange={(e) => {
                        selectAssignee(
                          e,
                          prop.phaseIndex,
                          prop.stepIndex,
                          prop.reviewIndex,
                          user,
                          index,
                          prop.multiAssignee
                        );
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={prop.reviewIndex + "-" + user.userId}
                     
                    >
                      {user.firstName +
                        " " +
                        user.lastName +
                        " (" +
                        user?.roleSet?.displayName +
                        " )" +
                        " (" +
                        user.depart.map((d, i) => {
                          if (user.depart.length === i + 1) {
                            return d;
                          } else {
                            return " "+ d;
                           }
                        }) +
                        " )"}
                    </label>
                  </div>
                );
              })}
            </div>
          ) : null}
          {otherFinalUsers.length > 0 ? (
            <div className="group-radio-list">
              <div
                style={{
                  padding: "10px",
                  margin: "15px 0 10px 0",
                  fontWeight: "600",
                }}
              >
                <span>Other Users</span>
              </div>

              {otherFinalUsers.map((user, userindex) => {
                return (
                  <div className="radio-form-check" key={`oth-${userindex}`}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={
                        prop.defaultSelectedUsers.length > 0 ?
                        prop.multiAssignee ?
                        prop.defaultSelectedUsers.some(element => {
                          if (element.userId === user.userId) {
                            return true;
                          }
                          return false;
                        }) : 
                        prop.defaultSelectedUsers[0]?.userId === user.userId :
                        false
                      }
                      id={`internal-${user.userId}`}
                     
                      onKeyDown={(e) => {selectAssignee(
                        e,
                        prop.phaseIndex,
                        prop.stepIndex,
                        prop.reviewIndex,
                        user,
                        userindex,
                        prop.multiAssignee
                      )}}
                      onChange={(e) => {
                        selectAssignee(
                          e,
                          prop.phaseIndex,
                          prop.stepIndex,
                          prop.reviewIndex,
                          user,
                          userindex,
                          prop.multiAssignee
                        );
                      }}
                    />
                    <label className="form-check-label" htmlFor={`internal-${user.userId}`}
                      onKeyDown={(e) => {selectAssignee(
                        e,
                        prop.phaseIndex,
                        prop.stepIndex,
                        prop.reviewIndex,
                        user,
                        userindex,
                        prop.multiAssignee
                      )}}
                    >
                      {user.firstName +
                        " " +
                        user.lastName +
                        " (" +
                        user.roleSet.displayName +
                        " )" +
                        " (" +
                        user.depart.map((d, i) => {
                          if (user.depart.length === i + 1) {
                            return d;
                          } else {
                            return d + " ";
                           }
                        }) +
                        " )"}
                    </label>
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  const EditWorkAssigneeComponent = (prop) =>{
    return (
      <div className="popover-body show">
        <div className="inner-popover">
          {workFinalAssigneeList.length > 0 ? (
            <div className="group-radio-list">
              <div
                style={{
                  padding: "10px",
                  marginBottom: "10px",
                  fontWeight: "600",
                }}
              >
                <span>Chose Assignee</span>
              </div>
              {workFinalAssigneeList.map((user, index) => {
                return (
                  <div className="radio-form-check" key={`rev-${index}`}>
                    <input
                      type="radio"
                      className="form-check-input"
                      value={user.userId}
                      checked={
                        prop.defaultSelectedUsers.length > 0 ? prop.defaultSelectedUsers[0]?.userId === user.userId : false
                      }
                      id={prop.reviewIndex + "-" + user.userId}
                      onChange={(e) => {
                        selectAssignee(
                          e,
                          prop.phaseIndex,
                          prop.stepIndex,
                          prop.reviewIndex,
                          user,
                          index
                        );
                      }}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={prop.reviewIndex + "-" + user.userId}
                    >
                      {user.firstName +
                        " " +
                        user.lastName +
                        " (" +
                        user?.roleSet?.displayName +
                        " )" +
                        " (" +
                        user.depart.map((d, i) => {
                          if (user.depart.length === i + 1) {
                            return d;
                          } else {
                            return d + " ";
                          }
                        }) +
                        " )"}
                    </label>
                  </div>
                );
              })}
            </div>
          ) : null}
          
        </div>
      </div>
    );
  }

  const getAssignees = (dept) => {
    var deptId = dept.id;
    var departName = dept.name;
    var langauageReviewers = [];
    var otherUsers = [];
    var translatorUsers = [];
    var workUser = [];
    getAxiosResponse(APIUrls.REVIEWABLE_ASSIGNEES(deptId)).then((res) => {
      if (res.data.code === 200) {
        res.data.data.map((user) => {
          user.customerUser.depart = [];
          if (
            (user.customerUser.roleSet.customerReviewer === true ||
              user.customerUser.roleSet.customerAdministrator === true) &&
            user.reviewLanguages !== ""
          ) {
            user.customerUser.depart = [];
            langauageReviewers.push(user.customerUser);
          } else if (
            user.customerUser.roleSet.customerInternalTranslator === true
          ) {
            user.customerUser.depart = [];
            translatorUsers.push(user.customerUser);
          } else {
            user.customerUser.depart = [];
            otherUsers.push(user.customerUser);
          }
        });

        setLangauageReviewers((current) => [
          ...current,
          { depart: departName, users: langauageReviewers },
        ]);
        setOtherUsers((current) => [
          ...current,
          { depart: departName, users: otherUsers },
        ]);
        setTranslators((current) => [
          ...current,
          { depart: departName, users: translatorUsers },
        ]);
      }
    });
    getAxiosResponse(APIUrls.WORK_ASSIGNEES(deptId)).then((res) => {
      if (res.data.code === 200) {
        res.data.data.map((user) => {
          user.customerUser.depart = [];
          workUser.push(user.customerUser);
        });
      }
      setWorkAssigneeList((current) => [
        ...current,
          { depart: departName, users: workUser },
      ])
    });
  };

  useEffect(() => {
    var reviewers = [];
    var otherUser = [];
    var translatros = [];
    var workAssignees = []
    if (
      workflow.userGroups !== undefined &&
      workflow.userGroups.length === langauageReviewers.length
    ) {
      if (langauageReviewers.length > 0) {
        langauageReviewers.map((rev) => {
          rev.users.map((user) => {
            if(!user.depart.includes(rev.depart)){
              user.depart.push(rev.depart);
            }
              
            var index = reviewers.findIndex(
              (object) => object.userId === user.userId
            );
            if (index === -1) {
              reviewers.push(user);
            } else {
              if(!reviewers[index].depart.includes(rev.depart)){
                reviewers[index].depart.push(rev.depart);
              }
            }
          });
        });
      }
      if (otherUsers.length > 0) {
        otherUsers.map((rev) => {
          rev.users.map((user) => {
            if(!user.depart.includes(rev.depart)){
              user.depart.push(rev.depart);
            }
            var index = otherUser.findIndex(
              (object) => object.userId === user.userId
            );
            if (index === -1) {
              otherUser.push(user);
            } else {
              if(!otherUser[index].depart.includes(rev.depart)){
                otherUser[index].depart.push(rev.depart);
              }
            }
          });
        });
      }
      
      if(workAssigneeList.length > 0){
        workAssigneeList.map((rev) => {
          rev.users.map((user) => {
            if(!user.depart.includes(rev.depart)){
              user.depart.push(rev.depart);
            }
            var index = workAssignees.findIndex(
              (object) => object.userId === user.userId
            );
            if (index === -1) {
              workAssignees.push(user);
            } else {
              if(!workAssignees[index].depart.includes(rev.depart)){
                workAssignees[index].depart.push(rev.depart);
              }
              
            }
          });
        });
      }
      if (translators.length > 0) {
        translators.map((rev) => {
          rev.users.map((user) => {
            user.depart.push(rev.depart);
            var index = translatros.findIndex(
              (object) => object.userId === user.userId
            );
            if (index === -1) {
              translatros.push(user);
            } else {
              translatros[index].depart.push(rev.depart);
            }
          });
        });
      }
      setLoader(false);
      setTimeout(() => {
         $('.lastdisable').trigger('focus');
      }, 100);
    }
    if(reviewers.length > 0){
      setFinalLangauageReviewers(reviewers);
    }
    if(otherUser.length > 0){
      setFinalOtherUsers(otherUser);
    }
    if(translatros.length > 0){
      setInternaltTranslators(translatros);
    }
    if(workAssignees.length > 0){
      setWorkFinalAssigneeList(workAssignees);
    }
  }, [langauageReviewers, otherUsers, translators, workflow,workAssigneeList]);

  const addNewSchedule = () => {
    setValidationErrors('')
    var copyWorkFlow = { ...workflow };
    copyWorkFlow.languages = [];
    copyWorkFlow.path = "";
    setLanguageReviewerTemplate((current) => [...current, copyWorkFlow]);
    setTimeout(() => {
       $('.removeSchedule').last().trigger('focus');
    }, 100);
  };
  const selectAssignee = (
    e,
    phaseIndex,
    stepIndex,
    reviewIndex,
    user,
    index,multiAssignee
  ) => {
    if(e.type === 'change' || e.code === 'Enter'){
      setValidationErrors('')
      var copylanguageReviewerTemplate = JSON.parse(
        JSON.stringify(languageReviewerTemplate)
      );
      var phaseAssigneeUsers = copylanguageReviewerTemplate[reviewIndex].steps[stepIndex].phases[phaseIndex].assigneeUsers !== '' ?
      copylanguageReviewerTemplate[reviewIndex].steps[stepIndex].phases[phaseIndex].assigneeUsers : []
      setValidationErrorForAssignee([]);
      setValidationErrors("");
      if(multiAssignee){
        if(phaseAssigneeUsers.length > 0 && phaseAssigneeUsers.some((id2) => id2.userId === user.userId)){
          var filteredUsers =  phaseAssigneeUsers.filter((usr)=>{
            return usr.userId !== user.userId
          })
          phaseAssigneeUsers = filteredUsers
        }else{
          phaseAssigneeUsers.push(user)
        }
        copylanguageReviewerTemplate[reviewIndex].steps[stepIndex].phases[phaseIndex].assigneeUsers = phaseAssigneeUsers
        setLanguageReviewerTemplate(copylanguageReviewerTemplate)
          $(`review${reviewIndex}step${stepIndex}phase${phaseIndex}`).trigger("focus")
        setShowEditAssignee("");
      }else{
      var selectedSingleUser = [];
      selectedSingleUser[0] = user;
      copylanguageReviewerTemplate[reviewIndex].steps[stepIndex].phases[phaseIndex].assigneeUsers = selectedSingleUser;
      setLanguageReviewerTemplate(copylanguageReviewerTemplate);
      setShowEditAssignee("");
      }
    }if(e.code === 'Escape'){
      setShowEditAssignee("");
    }
  };

  const getWorkflowById = () => {
    getAxiosResponse(APIUrls.GET_WORKFLOW_BY_ID(param.id)).then((res) => {
      if (res.data !== "") {
        setWorkflow(res.data.data);
        if (languageReviewerTemplate.length === 0) {
        }
        setSteps(res.data.data.steps);
        res.data.data.userGroups.map((depart) => {
          getAssignees(depart);
        });
      }
    });
  };
  const hideIntendentModel = () => {
    $('.addLangFocus').trigger("focus");
    $('.addLangFocus').removeClass("addLangFocus");
    setShowHideModel(false);
    document.body.classList.remove("modal-open");
  };
  const showModel = (index) => {
    $(document.activeElement).addClass('addLangFocus');
    showHideModel ? setShowHideModel(false) : setShowHideModel(true);
    setReviewIndex(index);
    var filteredLangs = targetLanguages.filter(
      (id1) => !defaultSelectedLangs.some((id2) => id1.value.code === id2.code)
    );
    setFilteredLanguagesForSchedule(filteredLangs);

    document.body.classList.add("modal-open");
    setTimeout(() => {
      $(".first-focus").trigger("focus");
    }, 500);
  };
  const selectLangs = (e, lang) => {
    if (e.target.checked) {
      setLanguageSelect((current) => [...current, lang]);
    } else {
      setLanguageSelect(
        selectedLanguages.filter((selectedLang) => {
          return selectedLang.code !== lang.code;
        })
      );
    }
  };
  const selectAllRemainingLanguge = () => {
    setLanguageSelect([])
    filteredLanguagesForSchedule.map((lang) => {
      setLanguageSelect((current) => [...current, lang.value]);
    });
  };
  const handleKeyOkflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $(".project-request div:first input").trigger("focus");
      }
    }
  };
  const addLangToScheduleKeydown = (event) => {
    if ($(".project-request div").first().find('input').is(':focus') &&
        event.key === Constants.TAB &&
        event.shiftKey
      ) {
      event.preventDefault();
      if ($('#OkId').is(':disabled')) {
        $(".first-focus").trigger("focus");
      } else {
        $("#OkId").trigger("focus");
      }
    } else if ($('.first-focus').is(':focus') &&
        event.key === Constants.TAB &&
        !event.shiftKey && $('#OkId').is(':disabled')
      ) {
      event.preventDefault();
      $(".project-request div:first input").trigger("focus");
    } else if (event.key === Constants.ESCAPE) {
      hideIntendentModel();
    }
  };
  const addLangaugeToSchedule = () => {
    setValidationErrors("");
    setFilteredLanguagesForSchedule((current) => [...current]);
    var copyLanguageReviewerTemplate = structuredClone(
      languageReviewerTemplate
    );
    selectedLanguages.map((lang, index) => {
      setDefaultSelectedLangs((current) => [...current, lang]);
      if (
        copyLanguageReviewerTemplate[reviewIndexForLanguage].languages === ""
      ) {
        copyLanguageReviewerTemplate[reviewIndexForLanguage].languages = [lang];
      } else {
        copyLanguageReviewerTemplate[reviewIndexForLanguage].languages.push(
          lang
        );
      }
    });
    setLanguageReviewerTemplate(copyLanguageReviewerTemplate);
    setLanguageSelect([]);
    hideIntendentModel();
  };
  const removeLanguage = (index, language) => {
    setValidationErrors('')
    var copyLanguageReviewerTemplate = structuredClone(
      languageReviewerTemplate
    );
    setFilteredLanguagesForSchedule((current) => [
      ...current,
      { label: language.display, value: language },
    ]);
    var filterLangs = languageReviewerTemplate[index].languages.filter(
      (slectedLangs) => {
        return slectedLangs.code !== language.code;
      }
    );
    var defultFilteredLang = defaultSelectedLangs.filter((slectedLangs) => {
      return slectedLangs.code !== language.code;
    });
    setDefaultSelectedLangs(defultFilteredLang);
    copyLanguageReviewerTemplate[index].languages = filterLangs;
    setLanguageReviewerTemplate(copyLanguageReviewerTemplate);
    
    const selectedElement = $(document.activeElement).closest("div");
    if($(document.activeElement).is(':last-child') &&
    selectedElement.children().length > 1){
       selectedElement.find('button').eq(-2).trigger('focus');
    } else if($(document.activeElement).is(':last-child')){
       $(document.activeElement).closest(".multiselect-output").find("div:first-child button").trigger('focus');
    }
  };
  const confirmDelete = (reviewIndex, id, review) => {
    $(document.activeElement).addClass('delFocus');
    setTimeout(() => {
      $("#react-confirm-alert").attr({
        'aria-modal': 'true',
        'role': 'dialog',
        'aria-labelledby':"removeSchedule"
        });
        $("h1").attr({
        'id': 'removeSchedule',
       });
      }, 200);
    setTimeout(()=>{
      $('#cancelRemoveLang').focus()
    },500)
    confirmAlert({
      title: "Remove Schedule",
      message: (
        <p>{`Removing schedule cannot be undone, please click 'Save' to save the changes. Are you sure you want to remove?`}</p>
      ),
      buttons: [
        {
          id:"confirmRemoveLang",
          label: "Yes",
          className:"blue-btn",
          onClick: () => removeSchedule(reviewIndex, id, review),
          onKeyDown : (e) => {
            if(e.key === Constants.TAB && e.shiftKey){
              e.preventDefault()
               $('#cancelRemoveLang').trigger('focus');
            }
          }
        },
        {
          label: "No",
          id:"cancelRemoveLang",
          className:"active",
          onKeyDown : (e) => {
            if(e.key === Constants.TAB && !e.shiftKey){
              e.preventDefault()
               $('#confirmRemoveLang').trigger('focus');
            }
          }
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "delete_overlay",
      afterClose: () => {
        if ($(document.activeElement).hasClass('lastdisable')) {
           $('.lastdisable').trigger('focus');
          return;
        } else {
           $('.delFocus').trigger("focus");
           $('.delFocus').removeClass("delFocus");
        }
      },
    });
  };
  const removeSchedule = (reviewIndex, id, review) => {
    setValidationErrors('')
    var remainingSelectedLangs = []
      remainingSelectedLangs = defaultSelectedLangs.filter(
        (selected) => !review.languages.some((id2) => selected.code === id2.code)
      );
   
    setDefaultSelectedLangs(remainingSelectedLangs);
    var copyLanguageReviewerTemplate = structuredClone(
      languageReviewerTemplate
    );
    var newCopy = copyLanguageReviewerTemplate.filter((lang, index) => {
      return reviewIndex !== index;
    });
    setLanguageReviewerTemplate(newCopy);
     $('.lastdisable').trigger('focus');
  };
  useEffect(() => {
    getAxiosResponse(APIUrls.TARGET_LANGUAGE).then((res) => {
      var langArray = [];
      if (res.data !== undefined && res.data !== "") {
        res.data.data.map((langs) => {
          langArray.push({
            label: langs.display,
            value: langs,
          });
        });

        setTargetLanguages(langArray);
      }
    });

    getWorkflowById();
  }, []);

  const getInitialiseWorkFlowData = () =>{
    getAxiosResponse(APIUrls.GET_INITIALIZE_WORKFLOW_RESOURCE(param.id)).then(
      (res) => {
        if (res.data.data.resource.length !== 0) {
          var languages = res.data.data?.displayName[0];
          var resource = res.data.data?.resource;
          var FinalData = [];
          setDefaultSelectedLangs(languages);
          var filteredLangs = targetLanguages.filter(
            (id1) => !languages.some((id2) => id1.value.code === id2.code)
          );
          setFilteredLanguagesForSchedule(filteredLangs);

          resource.map((data, index) => {
            data.languages = [languages[index]];
            FinalData.push(data);
          });
          if (languageReviewerTemplate.length === 0) {
            setLanguageReviewerTemplate(FinalData);
          }
        } else {
          setFilteredLanguagesForSchedule(targetLanguages);
        }
      }
    );
  }
  useEffect(() => {
    getInitialiseWorkFlowData()
  }, [targetLanguages, ""]);

  useEffect(() => {
    var filteredLangs = targetLanguages.filter(
      (id1) => !defaultSelectedLangs.some((id2) => id1.value.code === id2.code)
    );
    setFilteredLanguagesForSchedule(filteredLangs);
  }, [defaultSelectedLangs]);

  useEffect(() => {
    if (languageReviewerTemplate.length === 0 && workflow.length !== 0) {
      setLanguageReviewerTemplate([workflow]);
    }
  }, [workflow]);

  const getWorkflowGroupFromLanguageCode = (langCode) => {
    return targetLanguages.filter((lang) => {
      return lang.value.code === langCode;
    });
  };

  const markWorkflowGroupsWithError = (error) => {
    var workflowGroupErrors = error.split(Constants.SEMI_COLON);
    var errors = [];
    workflowGroupErrors.map((groupError) => {
      var wfgError = groupError.split(Constants.UNDERSCORE);
      if (wfgError.length > 1) {
        var valError =
          "There was an error with your workflow submission, please make sure assignees are set and atleast one language is added to a schedule.";
        setValidationErrors(valError);
        //groupError is of type stepNum_phaseNum_langCode.
        //assignee error
        var erroneousStep = wfgError[0];
        var erroneousPhase = wfgError[1];
        var erroneousLanguage = wfgError[2];
        var errorLangauge = getWorkflowGroupFromLanguageCode(erroneousLanguage);
        errors.push(
          `lang-${errorLangauge[0].value.code}-step-${erroneousStep}-phase-${erroneousPhase}`
        );
      } else {
        setValidationErrors(wfgError[0]);
      }
    });
    setValidationErrorForAssignee(errors);
  };

  const findValidationError = (stepNumber, phaseNumber, review) => {
    if (
      validationErrorForAssignee.length > 0 && review[0] !== undefined &&
      validationErrorForAssignee.includes(
        `lang-${review[0].code}-step-${stepNumber}-phase-${phaseNumber}`
      )
    ) {
      return true;
    }
  };

  const saveLangReviewTemplate = () => {
    setValidationErrors('')
    var copyLangReview = structuredClone(languageReviewerTemplate);
    languageReviewerTemplate.map((review, reviewIndex) => {
      if (review.languages !== "") {
        review.languages.map((langs, index) => {
          if (langs.name !== undefined) {
            copyLangReview[reviewIndex].languages[index] = langs.name;
          } else if (langs.name === undefined) {
            copyLangReview[reviewIndex].languages[index] = langs.language;
          }
        });
      }
    });
    var payload = transformBlankToNull(copyLangReview);
    putAxiosResponse(APIUrls.UPDATE_LANGUAGE_REVIEWER(param.id), payload).then(
      (res) => {
        if (res.data && res.data.data && res.data.data.body && res.data.data.body.errors.error) {
          markWorkflowGroupsWithError(res.data.data.body.errors.error);
          setTimeout(() => {
            if(errorRef !== null){
              errorRef.current.focus();
            }
            getWorkflowById()
          }, 1000);
        } else {
          setSucessMessageStatus(true);
          setTimeout(()=>{
            setSucessMessageStatus(false);
            getWorkflowById()
          },10000)
        }
      }
    );
  };
  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Review workflow template', url:'settings/review-workflow'},
    {label:'Edit  workflow template', url: `settings/workflow/${param.id}`},
    {label:'Add language reviewer', url: ''}
  ];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          {loader ? (
            <div className="gb-loader">
              <RotatingLines
                strokeColor="#0096FF"
                strokeWidth="5"
                width="196"
                visible={true}
              />
            </div>
          ) : (
            <div id="content" className="dashboard-wrap">
              <Breadcrumb crumbs={ crumbs } />
              <div className="project-setting-page">
                <div className="project-heading userprofile-heading">
                  <div className="back-arrow flex-center">
                    <button
                      aria-label="back"
                      onClick={() => navigate("/settings/review-workflow")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="13"
                        viewBox="0 0 14 13"
                        fill="none"
                      >
                        <path
                          d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                          fill="#1D4ED8"
                        />
                      </svg>
                    </button>
                    <span> Return to Review Workflow Templates</span>
                  </div>
                  <h3 className="flex">Language Reviewer Template</h3>
                  <span>
                    Configure language reviewers for your workflow template. Please
                    make sure that the reviewer(s) you would like to set here
                    are part of the department(s) that are configured on the
                    previous page.
                  </span>
                </div>
                <div className="white-bg">
                  <div
                    className={
                      languageUpdateSucess
                        ? "success-message"
                        : "success-message hide"
                    }
                  >
                    <span>
                      Language reviewer settings successfully updated.
                    </span>
                    <button
                      className="cross"
                      onClick={() => setSucessMessageStatus(false)}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M6.57812 6.90625L13.048 13.0938M13.048 6.90625L6.57812 13.0938L13.048 6.90625Z"
                          stroke="#2A4274"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M9.81402 18.5938C14.7768 18.5938 18.7999 14.7462 18.7999 10C18.7999 5.2538 14.7768 1.40625 9.81402 1.40625C4.85125 1.40625 0.828125 5.2538 0.828125 10C0.828125 14.7462 4.85125 18.5938 9.81402 18.5938Z"
                          stroke="#2A4274"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                    </button>
                  </div>
                  <div className="create-new-review-workflow">
                    <div className="language-schedule-block flex flex-center">
                      <button className="pending-schedule mar-bot14 readonly">
                        <strong>{filteredLanguagesForSchedule.length}</strong>
                        <span>Languages Pending Schedule</span>
                      </button>
                    </div>
                    {validationErrors ? (
                      <p ref={errorRef} tabIndex={0} className="error">
                        {validationErrors}
                      </p>
                    ) : (
                      ""
                    )}
                    {languageReviewerTemplate.length !== 0 ? (
                      languageReviewerTemplate.map((review, reviewIndex) => {
                        let workflowCode = review.workflowType.code;
                        return (
                          <div
                            className="workflow-language-reviewer"
                            key={reviewIndex}
                          >
                            <div className="flex language-reviewer-heading">
                              <h6>Language Schedule {reviewIndex + 1}</h6>
                              {languageReviewerTemplate.length > 1 ? (
                                <button
                                  className="removeSchedule"
                                  onClick={() =>
                                    confirmDelete(
                                      reviewIndex,
                                      review.id,
                                      review
                                    )
                                  }
                                >
                                  <svg
                                    className="aaa-change-icon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="21"
                                    height="21"
                                    viewBox="0 0 21 21"
                                    fill="none"
                                  >
                                    <path
                                      d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z"
                                      fill="#1D4ED8"
                                    />
                                    <path
                                      d="M15.1267 15.1271C14.8925 15.3613 14.5169 15.3613 14.2827 15.1271L10.4998 11.3442L6.71699 15.1271C6.48278 15.3613 6.10715 15.3613 5.87293 15.1271C5.63871 14.8929 5.63871 14.5172 5.87293 14.283L9.65576 10.5002L5.87293 6.71735C5.63871 6.48313 5.63871 6.1075 5.87293 5.87328C5.98783 5.75838 6.1425 5.69652 6.29275 5.69652C6.443 5.69652 6.59768 5.75397 6.71257 5.87328L10.4954 9.65611L14.2782 5.87328C14.3931 5.75838 14.5478 5.69652 14.6981 5.69652C14.8527 5.69652 15.003 5.75397 15.1179 5.87328C15.3521 6.1075 15.3521 6.48313 15.1179 6.71735L11.3439 10.5002L15.1267 14.283C15.3609 14.5172 15.3609 14.8929 15.1267 15.1271Z"
                                      fill="#1D4ED8"
                                    />
                                  </svg>
                                  <span>Remove Schedule</span>
                                </button>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="workflow-wrap">
                              {review.steps.map((step, stepIndex) => {
                                return (
                                  <div
                                    className="workflow-step-list open-step"
                                    style={{ marginRight: "40px" }}
                                    key={stepIndex}
                                  >
                                    <div className="inner-step-list">
                                      <button className="step-btn" onClick={(e) => {toggleStepExpansion(e)}}>
                                        <i className="plus-icon" onClick={(e) => {toggleStepExpansion(e)}}></i>
                                        {step.name}
                                      </button>
                                      <div className="workflow-step-content popup-padding flex">
                                        {step.phases.map(
                                          (phase, phaseIndex) => {
                                            return (
                                              <div
                                                className="step-box-list"
                                                key={phaseIndex}
                                              >
                                                {phase.durationInDays !== "" ? (
                                                  <button
                                                    className="step-cal flex-center"
                                                    aria-label="calender"
                                                    aria-expanded="false"
                                                  >
                                                    <span>
                                                      {phase.durationInDays > 1
                                                        ? phase.durationInDays +
                                                          " days"
                                                        : phase.durationInDays +
                                                          " day"}
                                                    </span>
                                                  </button>
                                                ) : null}

                                                {getPhaseName(
                                                  phase,
                                                  step,
                                                  phaseIndex,
                                                  stepIndex
                                                )}
                                                {phase.assigneeType
                                                  .originalEnum === "MACHINE_TRANSLATOR" ? (
                                                  <strong>
                                                    MT
                                                  </strong>
                                                ) : phase.assigneeType.originalEnum === "VENDOR" ? phase.phaseType.code ==="post_editing" ?
                                                  ( <strong> PE </strong>):(
                                                    <strong>
                                                     {phase.assigneeType.display}
                                                    </strong>
                                                ) : (
                                                  <div className="step-assignee">
                                                    <div
                                                      className="step-assignee flex-center justify-center"
                                                      role="button"
                                                      tabIndex={0}
                                                      id={`review${reviewIndex}step${stepIndex}phase${phaseIndex}`}
                                                      style={findValidationError(
                                                          step.stepNumber,
                                                          phase.phaseNumber,
                                                          review.languages
                                                        )
                                                          ? {border:"2px solid #A61616",padding:"0px 2px",borderRadius:"5px"}
                                                          : null
                                                      }
                                                      onKeyDown={(e) =>
                                                        toggleAssignee(
                                                          reviewIndex,
                                                          stepIndex,
                                                          phaseIndex,
                                                          e
                                                        )}
                                                      onClick={(e) =>
                                                        toggleAssignee(
                                                          reviewIndex,
                                                          stepIndex,
                                                          phaseIndex,
                                                          e
                                                        )
                                                      }
                                                    >
                                                      <div className="flex-center width-140">
                                                        {phase.allowMultiAssignee ? 
                                                        <>
                                                      {phase.assigneeUsers.length > 0 ? <span aria-label={`${phase.assigneeUsers.length} Reviewers selected`}  className="pl-5">{phase.assigneeUsers.length} {phase.assigneeUsers.length === 1 ? 'Reviewer':'Reviewers'}</span> : <span>Multiple Assignees</span>}
                                                      {ActiveMultiAssigneeIcon}
                                                      </> : 
                                                       <>
                                                        <span>
                                                          {phase.assigneeUsers[0]?.firstName !== undefined ? phase.assigneeUsers[0]?.firstName +" " +phase.assigneeUsers[0]?.lastName
                                                            : "Assignee"}
                                                        </span>
                                                        {ActiveAssigneeManIcon}
                                                        </> }
                                                      </div>
                                                      {DownArrowIconWorkflow}{" "}
                                                    </div>
                                                    {showEditAssignee ===
                                                    `review${reviewIndex}step${stepIndex}phase${phaseIndex}` ? (
                                                      phaseIndex !== 0 ?
                                                      <EditAssigneeComponent
                                                        reviewIndex={
                                                          reviewIndex
                                                        }
                                                        multiAssignee={phase.allowMultiAssignee}
                                                        stepIndex={stepIndex}
                                                        phaseIndex={phaseIndex}
                                                        defaultSelectedUsers={
                                                          phase.assigneeUsers
                                                        }
                                                      /> : <EditWorkAssigneeComponent 
                                                      reviewIndex={
                                                        reviewIndex
                                                      }
                                                      stepIndex={stepIndex}
                                                      phaseIndex={phaseIndex}
                                                      defaultSelectedUsers={
                                                        phase.assigneeUsers
                                                      }
                                                            />
                                                    ) : null}
                                                  </div>
                                                )}
                                                {!phase.allowRevision ? (
                                                  <div className="step-request">
                                                    <div className="left-icon">
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="14"
                                                        height="12"
                                                        viewBox="0 0 14 12"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M13.5303 6.53033C13.8232 6.23744 13.8232 5.76256 13.5303 5.46967L8.75736 0.696699C8.46447 0.403806 7.98959 0.403806 7.6967 0.696699C7.40381 0.989593 7.40381 1.46447 7.6967 1.75736L11.9393 6L7.6967 10.2426C7.40381 10.5355 7.40381 11.0104 7.6967 11.3033C7.98959 11.5962 8.46447 11.5962 8.75736 11.3033L13.5303 6.53033ZM0 6.75H13V5.25H0V6.75Z"
                                                          fill="#1D4ED8"
                                                        ></path>
                                                      </svg>
                                                    </div>
                                                    <span>
                                                      Cannot Request Revision
                                                    </span>
                                                  </div>
                                                ) : (
                                                  <div className="step-request">
                                                    <span className="revision-allowed pl-0">
                                                      Can Request Revision
                                                    </span>
                                                    <div className="left-icon">
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 64 64"
                                                        width="30"
                                                        height="23"
                                                      >
                                                        <path
                                                          d="M 22 12 C 16.486 12 12 16.486 12 22 L 12 23 C 12 24.104 12.896 25 14 25 C 15.104 25 16 24.104  16 23 L 16 22 C 16 18.691 18.691 16 22 16 L 42 16 C 45.309 16 48 18.691 48 22 L 48 24 L 45.107422 24 C  44.213422 24 43.685313 25.003281 44.195312 25.738281 L 49.089844 32.8125 C 49.529844 33.4495 50.471109  33.4495 50.912109 32.8125 L 55.806641 25.738281 C 56.314641 25.003281 55.788531 24 54.894531 24 L 52 24 L  52 22 C 52 16.486 47.514 12 42 12 L 22 12 z M 14 30.708984 C 13.654375 30.708984 13.308391 30.869 13.087891  31.1875 L 8.1953125 38.261719 C 7.6873125 38.996719 8.2134219 40 9.1074219 40 L 12 40 L 12 42 C 12 47.514  16.486 52 22 52 L 42 52 C 47.514 52 52 47.514 52 42 L 52 41 C 52 39.896 51.104 39 50 39 C 48.896 39 48  39.896 48 41 L 48 42 C 48 45.309 45.309 48 42 48 L 22 48 C 18.691 48 16 45.309 16 42 L 16 40 L 18.892578  40 C 19.786578 40 20.314688 38.996719 19.804688 38.261719 L 14.910156 31.1875 C 14.690156 30.869 14.345625  30.708984 14 30.708984 z"
                                                          fill="#1D4ED8"
                                                        ></path>
                                                      </svg>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            );
                                          }
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                            <div className="multiselect-output flex">
                              <div>
                                <button
                                  className="dashboard-btn"
                                  onClick={() => showModel(reviewIndex)}
                                  disabled={filteredLanguagesForSchedule.length === 0}
                                >
                                  <svg
                                    className="plus-icon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                  >
                                    <path
                                      d="M6 1V11"
                                      stroke="#1D4ED8"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                    <path
                                      d="M1 6H11"
                                      stroke="#1D4ED8"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    ></path>
                                  </svg>
                                  Add Languages to Schedule
                                </button>
                              </div>
                              <div>
                                {review.languages !== undefined &&
                                review.languages.length > 0
                                  ? review.languages.map((lang, index) => {
                                      return (
                                        <button
                                          aria-label={
                                            "remove " + (lang.display !==
                                            undefined
                                              ? lang.display
                                              : lang)
                                          }
                                          key={index}
                                          onClick={() =>
                                            removeLanguage(reviewIndex, lang)
                                          }
                                        >
                                          <strong>
                                            {lang.display !== undefined
                                              ? lang.display
                                              : lang}
                                          </strong>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="10"
                                            height="9"
                                            viewBox="0 0 10 9"
                                            fill="none"
                                          >
                                            <path
                                              d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                              stroke="#213248"
                                              strokeWidth="1.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            ></path>
                                          </svg>
                                        </button>
                                      );
                                    })
                                  : null}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <h3>Loading</h3>
                    )}

                    <button
                      className="dashboard-btn mar-bot14"
                      onClick={addNewSchedule}
                      disabled={filteredLanguagesForSchedule.length === 0}
                    >
                      <svg
                        className="plus-icon"
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <path
                          d="M6 1V11"
                          stroke="#1D4ED8"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                        <path
                          d="M1 6H11"
                          stroke="#1D4ED8"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        ></path>
                      </svg>
                      Add New Schedule
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </section>
        {showHideModel ? (
          <div
            className="lightbox-panel create"
            aria-labelledby="addIntended"
            aria-modal="true"
            role="dialog"
            onKeyDown={(e)=>addLangToScheduleKeydown(e)}
          >
            <div className="inner-lightbox-panel pb-0">
              <div className="modal-header flex padd-lr">
                <h5 id="addIntended">Add Languages to Schedule</h5>
              </div>
              <div
                className="flex btn-gap"
                style={{
                  padding: "8px",
                  borderBottom: "1px solid grey",
                  color: "blue",
                }}
              >
                <button className="selectColor" onClick={selectAllRemainingLanguge}>Select All</button>
                {selectedLanguages.length > 1 ? (
                  <button
                    className="link-button selectColor"
                    onClick={() => setLanguageSelect([])}
                  >
                    Deselect All
                  </button>
                ) : (
                  ""
                )}
              </div>
              <div
                className="lightbox-content padd-22"
                style={{ maxHeight: "300px", overflow: "auto" }}
              >
                <div className="flex wrap-dropdown mb-0 project-request">
                  {filteredLanguagesForSchedule.map((langs, index) => {
                    return (
                      <div
                        className={`form-check small-checkbox ${
                          filteredLanguagesForSchedule.length - index
                        }`}
                        style={{ padding: "0 5px 0 5px" }}
                        key={filteredLanguagesForSchedule.length - index}
                      >
                        <input
                          className={
                            selectedLanguages.some(
                              (e) => e.code === langs.value.code
                            )
                              ? "form-check-input selected"
                              : "form-check-input "
                          }
                          type="checkbox"
                          name={langs.value.code}
                          id={langs.value.code}
                          onChange={(e) => selectLangs(e, langs.value)}
                          checked={selectedLanguages.some(
                            (e) => e.code === langs.value.code
                          )}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={langs.value.code}
                        >
                          {langs.label}
                        </label>
                      </div>
                    );
                  })}
                </div>
                <div className="flex wrap-dropdown mb-0">
                  <strong>Selected language(s) : </strong>
                  {selectedLanguages.map((langs, index) => {
                    if (selectedLanguages.length === index + 1) {
                      return <React.Fragment key={index}>&nbsp;<span >{langs.display} </span></React.Fragment>;
                    } else {
                      return <React.Fragment key={index}>&nbsp;<span key={index}>{langs.display}{", "} </span></React.Fragment>;
                    }
                  })}
                </div>
              </div>
              <div className="modal-footer modal-footer-border flex px-22">
                <button
                  className="btn btn-bold first-focus"
                  onClick={()=>{setLanguageSelect([]);hideIntendentModel()}}
                >
                  Cancel
                </button>
                <button
                  onKeyDown={handleKeyOkflow}
                  id="OkId"
                  className="btn btn-bold active"
                  disabled={selectedLanguages.length === 0}
                  onClick={addLangaugeToSchedule}
                >
                  Add Languages to Schedule
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
      <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex">
          <div>
            <button
              className="btn-default"
              onClick={() => navigate(`/settings/workflow/${param.id}`)}
            >
              Cancel
            </button>
          </div>
          <div>
            <button className="btn-default" onClick={saveLangReviewTemplate}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
